import React from 'react'

const HomeIcon = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.3284 10.8738L24.3267 10.8721L14.1277 0.674438C13.6929 0.239563 13.115 0 12.5002 0C11.8854 0 11.3074 0.239372 10.8724 0.674248L0.67873 10.8667C0.675296 10.8702 0.671862 10.8738 0.668429 10.8772C-0.224301 11.775 -0.222775 13.2317 0.672816 14.1272C1.08198 14.5365 1.62239 14.7736 2.20019 14.7984C2.22365 14.8006 2.2473 14.8018 2.27115 14.8018H2.67764V22.3066C2.67764 23.7917 3.88607 25 5.37167 25H9.36187C9.76626 25 10.0944 24.6721 10.0944 24.2676V18.3838C10.0944 17.7061 10.6456 17.1549 11.3234 17.1549H13.6769C14.3547 17.1549 14.9059 17.7061 14.9059 18.3838V24.2676C14.9059 24.6721 15.2339 25 15.6384 25H19.6286C21.1142 25 22.3227 23.7917 22.3227 22.3066V14.8018H22.6996C23.3142 14.8018 23.8922 14.5624 24.3273 14.1275C25.2239 13.2305 25.2242 11.7714 24.3284 10.8738Z"
        fill={color}
      />
    </svg>
  )
}

export default HomeIcon
